module.exports = __webpack_public_path__ + "static/media/source_book_1.b62013e8.png";